<template>
  <div>
    <i
      v-if="didRollover.hasIcon"
      :id="`didRollover${tab}${row.skId}`"
      :class="didRollover.iconClass"
    ></i>
    <span v-if="didRollover.hasIcon">&times;{{ row.rolloversCount }}</span>
    <tooltip
      v-if="didRollover.hasIcon"
      :text="didRollover.tooltip"
      :target="`#didRollover${tab}${row.skId}`"
      placement="bottom"
    />
    <a :href="orderUrl">{{ row.skOrderNum }}</a>
    <br />
    <span>{{ row.status }}</span>
    <br />
    <i
      v-if="uploadStatus.hasIcon"
      :id="`dtStatus${tab}${row.skId}`"
      :class="uploadStatus.iconClass"
      placement="bottom"
    ></i>
    <tooltip
      v-if="uploadStatus.hasIcon"
      :text="uploadStatus.tooltip"
      :target="`#dtStatus${tab}${row.skId}`"
    />
    <b>{{ cod }}</b>
    <CommonCarrierTracker :order="row" />
  </div>
</template>

<script>
import CommonCarrierTracker from '../../CommonCarrierTracker.vue';
export default {
  name: 'tdStatus',
  props: ['row', 'xprops'],
  components: {
    CommonCarrierTracker,
  },
  computed: {
    orderUrl() {
      const { skId, type } = this.row;
      switch (type) {
        case 'delivery':
        case 'crossdock':
        case 'crossdock_delivery':
          return `/#deliveries/${skId}`;
        case 'pickup':
        case 'crossdock_pickup':
          return `/#pickups/${skId}`;
        case 'transfer':
          return `/#transfers/${skId}`;
      }
    },
    cod() {
      const { cod } = this.row;
      switch (cod) {
        case 'cod_requested':
          return 'COD';
        case 'cod_required':
          return '*COD*';
        default:
          return '';
      }
    },
    uploadStatus() {
      const { dtUploadStatus } = this.row;

      if (dtUploadStatus === true) {
        return {
          hasIcon: true,
          iconClass: 'glyphicon glyphicon-ok-sign',
          tooltip: 'Successfully uploaded to Dispatch Track',
        };
      }

      if (dtUploadStatus === false) {
        return {
          hasIcon: true,
          iconClass: 'glyphicon glyphicon-remove-sign',
          tooltip: 'Failed to upload to Dispatch Track',
        };
      }

      return {
        hasIcon: null,
      };
    },
    didRollover() {
      const didRollover = this.row.didRollover;

      if (didRollover === true) {
        const count = this.row.rolloversCount;
        return {
          hasIcon: true,
          tooltip: `This order has been rolled over ${count} time(s)`,
          iconClass: 'glyphicon glyphicon-retweet',
        };
      }

      return {
        hasIcon: null,
      };
    },
    tab() {
      return this.xprops.tab;
    },
  },
};
</script>

<style scoped>
.glyphicon-ok-sign {
  color: green;
}
.glyphicon-remove-sign {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderTable/components/tdStatus.vue